import TemplateDropdown from "src/components/template/template-dropdown";
import * as React from "react";
import { useParams } from "react-router-dom";
import { useTeamSprints } from "src/scenes/teams/dashboard/selected-sprints-provider-teams";
import { useSprints } from "src/scenes/dashboard/selected-sprint-provider";

const JiraProjectSelector = ({ queryVariablesSetter, value, setValue }) => {
    const { teamId } = useParams();
    const { allProjects } = teamId ? useTeamSprints() : useSprints();

    if (!queryVariablesSetter || !queryVariablesSetter.project) return null;
    if (!allProjects || !allProjects.projects || !allProjects.projects.length) return null;
    return (
        <TemplateDropdown
            options={null}
            title="Jira Project"
            allValue="All"
            dynamicOptions={queryVariablesSetter.project.dynamicOptions}
            value={value}
            setValue={setValue}
            data={allProjects}
        />
    );
};

export default JiraProjectSelector;
